import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import * as XLSX from 'xlsx'
import orderApi from '../../api/order.api'
import promotionApi from '../../api/promotion.api'
import pushApi from '../../api/push.api'
import OrderDetailComponent from '../../components/sales/OrderDetailComponent'
import ContentHeader from '../../components/shared/ContentHeader'
import { searchValueState } from '../../store/searchValue'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/sales.module.scss'
import statusUtil from '../../utils/status'

const OrderSearchListPage = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [selectOrderList, setSelectOrderList] = useRecoilState(searchValueState)
  const [isLoading, setIsLoading] = useState(false)
  // const searchText = useSelector((state) => state.common.searchText);
  // const setIsSearchText = (value) => dispatch(setSearchText(value));

  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'paymentCreatedAt',
    searchStatus: 'total',
    searchOrderId: '',
    searchProductName: '',
    funnel: 0,
    name: '',
    phone: '',
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [orderType, setOrderType] = useState('paymentCreatedAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalOrderList, setTotalOrderList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [orderDetail, setOrderDetail] = useState({})
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)
  const [isDepositCancelModalOpen, setIsDepositCancelModalOpen] =
    useState(false)
  const [readyCancelShow, setReadyCancelShow] = useState(false)
  const [editCancelReason, setEditCancelReason] = useState({
    cancelReason: null,
    refundBank: null,
  })

  const [mobileColumn, setMobileColumn] = useState(false)

  const [cancelButtonShow, setCancelButtonShow] = useState(true)
  /**
   * 모바일 처리 mobile -> true
   */
  const [mediaResult, setMediaResult] = useState(null)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const matchQueryList = window.matchMedia('all and (max-width: 768px)')
      setMediaResult(matchQueryList.matches)
      if (!matchQueryList.matches) {
        setMobileColumn(false)
      }

      const media = function handleChange(e) {
        setMediaResult(e.matches)
        if (!e.matches) {
          setMobileColumn(false)
        }
      }

      matchQueryList.addEventListener('change', media)
    }
  }, [])

  const searchDateItems = [
    { searchText: '결제일', searchType: 'paymentCreatedAt' },
    // {searchText: '주문일시', searchType: 'order_created_at'}
  ]
  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const orderStatusItems = [
    { label: '전체', value: 'total' },
    { label: '입금대기', value: 'ready' },
    { label: '입금완료', value: 'paid' },
    // {label: '결제실패', value: 'failed'},
    { label: '결제취소', value: 'cancelled' },
    { label: '배송준비중', value: 'delivery_ready' },
    { label: '배송중', value: 'delivery_shipping' },
    { label: '배송완료', value: 'delivery_complete' },
    { label: '구매확정', value: 'complete' },
    { label: '취소요청', value: 'cancel_request' },
    { label: '취소완료', value: 'cancel_complete' },
    { label: '반품요청', value: 'return_request' },
    { label: '반품승인', value: 'return_receive' },
    { label: '반품거부/철회', value: 'return_refusal' },
    { label: '반품수거완료', value: 'return_collection_complete' },
    { label: '반품수거취소', value: 'return_collection_fail' },
    { label: '반품배송중', value: 'return_delivery' },
    { label: '반품배송완료', value: 'return_delivery_complete' },
    { label: '반품완료', value: 'return_complete' },
    { label: '교환요청', value: 'exchange_request' },
    { label: '교환완료', value: 'exchange_complete' },
  ]
  const funnelStatusItems = [
    { label: '전체', value: 0 },
    { label: '검색', value: 1 },
    { label: '전화주문', value: 4 },
    { label: '공동구매', value: 3 },
  ]
  const orderPair = {
    paymentCreatedAt: '결제일순',
    orderId: '주문번호순',
    // created_at: '주문일시순'
  }
  const cancelReasonItems = [
    { label: '미입금', value: '미입금' },
    { label: '상품품절', value: '상품품절' },
    { label: '배송지연', value: '배송지연' },
    { label: '서비스 불만족', value: '서비스 불만족' },
    { label: '구매의사취소', value: '구매의사취소' },
    { label: '색상 및 사이즈 변경', value: '색상 및 사이즈 변경' },
    { label: '다른 상품 잘못 주문', value: '다른 상품 잘못 주문' },
    { label: '상품정보 상이', value: '상품정보 상이' },
  ]
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = []
      let editRowList = []
      if (selected) {
        const filterList = totalOrderList.filter(
          (order) => order.orderId === record.orderId,
        )
        const filterKeyList = filterList.map((row) => row.orderDetailId)
        editRowList = [...selectedRow, ...filterList]
        editKeyList = [...selectedRowKey, ...filterKeyList]
      } else {
        editRowList = selectedRow.filter(
          (row) => row.orderId !== record.orderId,
        )
        editKeyList = editRowList.map((row) => row.orderDetailId)
      }
      setSelectedRowKey(editKeyList)
      setSelectedRow(editRowList)
    },
  }

  const columns = [
    {
      title: '주문번호',
      width: 80,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      align: 'right',
      // sorter: (a, b) => {},
      defaultSortOrder: 'descend',
      render: (value, record) => {
        return (
          <span
            className={`${styles['recommend-inquiry-list-title']}`}
            onClick={() => {
              setOrderDetail(record)
              setIsOrderModalOpen(true)
            }}
          >
            {value}
          </span>
        )
      },
    },
    {
      title: '상품주문번호',
      width: 90,
      dataIndex: 'orderDetailId',
      key: 'orderDetailId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '주문일시',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      sorter: (a, b) => {
        if (a.createdAt === null && b.createdAt === null) {
          return 0
        }
        if (a.createdAt === null) {
          return 1
        }
        if (b.createdAt === null) {
          return -1
        }
        return dayjs(b.createdAt).unix() - dayjs(a.createdAt).unix()
      },
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '결제일',
      width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (record.orderDetailStatus === 'ready') {
          return '-'
        } else if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품번호',
      // width: 200,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '상품명',
      // width: 200,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      // width: 200,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
    },
    {
      title: '수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '상품별 총 주문금액',
      // width: 150,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      ellipsis: true,
      align: 'right',
      render: (value) => {
        return value.toLocaleString()
      },
    },
    {
      title: '주문상태',
      width: 90,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      render: (value, record) => {
        if (
          Object.prototype.hasOwnProperty.call(record, 'isDeposit') &&
          record.isDeposit &&
          value === 'ready'
        ) {
          return '무통장 입금대기'
        } else {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: `정산 금액`,
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'return_delivery' &&
          record.orderDetailStatus !== 'return_delivery_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          let returnPrice = record.totalPrice
          // 공동구매
          if (record.isCooperate) {
            returnPrice =
              returnPrice -
              Math.floor(
                record.totalPrice * ((record.commissionRate * 1.1) / 100),
              )
            // 공동구매 시 - 당영 관리 수수료 반영 여부에 따라 처리
            if (record.useDyCommission && record.brandFeeRate) {
              const brandFee = record.includeBrandFeeVat
                ? record.brandFeeRate * 1.1
                : record.brandFeeRate
              returnPrice =
                returnPrice - Math.floor(record.totalPrice * (brandFee / 100))
            }
          }
          // 일반구매
          else {
            if (record.query) {
              returnPrice =
                returnPrice -
                Math.floor(
                  record.totalPrice * ((record.commissionRate * 1.1) / 100),
                )
            }
            if (record.brandFeeRate) {
              const brandFee = record.includeBrandFeeVat
                ? record.brandFeeRate * 1.1
                : record.brandFeeRate
              returnPrice =
                returnPrice - Math.floor(record.totalPrice * (brandFee / 100))
            }
          }
          return returnPrice.toLocaleString()
        } else {
          return 0
        }
      },
    },
    {
      title: `당영 관리 수수료`,
      // width: 200,
      dataIndex: 'brandFeeRate',
      key: 'brandFeeRate',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          // 일반 구매
          if (!record.isCooperate) {
            if (value) {
              const brandFee = record.includeBrandFeeVat ? value * 1.1 : value
              return (
                '-' +
                Math.floor(
                  record.totalPrice * (brandFee / 100),
                ).toLocaleString()
              )
            } else {
              return 0
            }
          }
          // 공동구매
          else {
            // 공동구매 시 - 당영 관리 수수료 반영 여부에 따라 처리
            if (record.useDyCommission && value) {
              const brandFee = record.includeBrandFeeVat ? value * 1.1 : value
              return (
                '-' +
                Math.floor(
                  record.totalPrice * (brandFee / 100),
                ).toLocaleString()
              )
            } else {
              return 0
            }
          }
        } else {
          return 0
        }
      },
    },
    {
      title: `매출 연동 수수료\n(VAT 포함)`,
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'return_delivery' &&
          record.orderDetailStatus !== 'return_delivery_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          if (record.query) {
            return record.totalPrice * ((record.commissionRate * 1.1) / 100) > 0
              ? '-' +
                  Math.floor(
                    record.totalPrice * ((record.commissionRate * 1.1) / 100),
                  ).toLocaleString()
              : 0
          } else {
            return 0
          }
        } else {
          return 0
        }
      },
    },
    {
      title: '웹/앱 유입',
      width: 90,
      align: 'center',
      dataIndex: 'memo',
      key: 'memo',
      ellipsis: true,
      render: (value, record) => {
        // 공동구매 아닌 인플루언서 결제 중 -> 웹/앱 구분
        if (record.query) {
          if (!record.isCooperate) {
            if (
              value &&
              value?.includes('app-true') &&
              !value.includes('web-true')
            ) {
              return 'App'
            } else {
              return 'Web'
            }
          }
        }
      },
    },
    {
      title: '매출연동수수료 유입경로',
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'center',
      render: (value, record) => {
        let path = ''
        if (value.query) {
          if (record.isCooperate) {
            path = '공동구매'
          } else {
            if (record?.isManual) {
              path = '전화주문-'
            }
            if (
              record?.influencerRole === 'super_admin' ||
              record?.influencerRole === 'level_1'
            ) {
              path += '인플루언서'
            } else {
              path += '셀러'
            }
          }
        } else if (record?.isManual) {
          path = '전화주문'
        } else {
          path = '검색'
        }
        return path
      },
    },
    {
      title: '해당 링크',
      // width: 150,
      dataIndex: 'query',
      key: 'query',
      ellipsis: true,
      render: (value, record) => {
        if (record.influencerName) {
          return record.influencerName
        } else {
          return value
        }
      },
    },
    {
      title: '클레임상태',
      width: 150,
      dataIndex: '',
      key: '',
    },
    {
      title: '구매자명',
      width: 90,
      dataIndex: 'createdByName',
      key: 'createdByName',
      ellipsis: true,
    },
    {
      title: '수취인명',
      width: 90,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: '연락처',
      // width: 90,
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: '주소',
      // width: 90,
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: '상세주소',
      // width: 90,
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      ellipsis: true,
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]

  const columnsChange = [
    {
      title: '수취인명',
      width: 90,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: '상품별 총 주문금액',
      // width: 150,
      width: 90,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString()
      },
    },
    {
      title: '주문상태',
      width: 90,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      render: (value, record) => {
        if (
          Object.prototype.hasOwnProperty.call(record, 'isDeposit') &&
          record.isDeposit &&
          value === 'ready'
        ) {
          return '무통장 입금대기'
        } else {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: '구매자명',
      width: 90,
      dataIndex: 'createdByName',
      key: 'createdByName',
      ellipsis: true,
    },
    {
      title: '수량',
      width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
    },
    {
      title: '주문번호',
      width: 90,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className={`${styles['recommend-inquiry-list-title']}`}
            onClick={() => {
              setOrderDetail(record)
              setIsOrderModalOpen(true)
            }}
          >
            {value}
          </span>
        )
      },
    },
    {
      title: '주문일시',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // defaultSortOrder: 'descend',
      // sorter: (a, b) => {
      //   if (a.createdAt === null && b.createdAt === null) {
      //     return 0
      //   }
      //   if (a.createdAt === null) {
      //     return 1
      //   }
      //   if (b.createdAt === null) {
      //     return -1
      //   }
      //   return dayjs(b.createdAt).unix() - dayjs(a.createdAt).unix()
      // },
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '결제일',
      width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (record.orderDetailStatus === 'ready') {
          return '-'
        } else if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품명',
      // width: 200,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      // width: 200,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
    },
    {
      title: '상품번호',
      // width: 200,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
    },
    {
      title: '클레임상태',
      width: 150,
      dataIndex: '',
      key: '',
    },
    {
      title: '연락처',
      // width: 90,
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: '주소',
      // width: 90,
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: '상세주소',
      // width: 90,
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      ellipsis: true,
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
                // display: 'flex',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]

  // useEffect(() => {
  // 	if (searchText && searchText !== " " && searchText === "ready") {
  // 		setSearchOptions({ ...searchOptions, searchStatus: "ready" });
  // 		getUserOrderList("custom", searchText);
  // 	}
  // }, [searchText]);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    // if (searchText && searchText !== " " && searchText === "ready") {
    // 	getUserOrderList("custom", searchText);
    // } else {
    // 	getUserOrderList();
    // }
    getUserOrderList()
  }, [orderType, orderBy])

  const getUserOrderList = async (type = '', searchStatus) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'orderTotalSearch',
          searchType: searchDateItems[0].searchType,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: orderStatusItems[0].value,
          searchOrderId: null,
          searchProductName: '',
          funnel: 0,
          name: '',
          phone: '',
          orderType: 'paymentCreatedAt',
          orderBy: 'desc',
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'orderTotalSearch',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'custom') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'orderTotalSearch',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'orderTotalSearch',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      }
      const res = await orderApi.searchOrderDetailList(param, user.id)
      // console.log('searchOrderDetailList res', res)
      if (res.data.code === 200) {
        // setTotalOrderList(res.data.result.userOrderDetailDTOList)
        setTotalOrderList([...res.data.result.userOrderDetailDTOList].reverse())
        if (type === 'initial' || type === 'search') {
          // setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
          setOrderList(
            [...res.data.result.userOrderDetailDTOList].reverse().slice(0, 10),
          )
        } else {
          // setOrderList(
          //   res.data.result.userOrderDetailDTOList.slice(
          //     offset,
          //     offset + pageSize,
          //   ),
          // )
          setOrderList(
            [...res.data.result.userOrderDetailDTOList]
              .reverse()
              .slice(offset, offset + pageSize),
          )
        }
        if (res.data.result?.length !== 0) {
          setTotalSize(res.data.result.totalCnt)
        } else {
          setTotalSize(0)
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getUserOrderList read error', error)
    }
  }

  /**
   * 입금 완료
   */
  const handleDepositComplete = async () => {
    if (
      window.confirm(
        '해당 주문들에 대한 결제 금액이 정상적으로 입금되었는지 다시 한번 확인해주세요.',
      )
    ) {
      setIsLoading(true)
      try {
        const orderIdSet = new Set(selectedRow.map((row) => row.orderId))

        const param = {
          orderIdList: [...orderIdSet],
        }
        const res = await orderApi.orderStatusEditForDeposit(param, user.id)
        if (res.data.code === 200) {
          setIsLoading(false)
          alert('해당 주문들에 대한 입금 완료 처리를 성공적으로 반영했습니다.')
          // if (searchText && searchText !== ' ' && searchText === 'ready') {
          //   getUserOrderList('custom', searchText)
          //   setOffset(0)
          //   setPageSize(10)
          //   setSelectedRowKey([])
          //   setSelectedRow([])
          // } else {
          //   handleInitialBtnClick()
          // }
          handleInitialBtnClick()
        } else if (res.data.code === 999) {
          throw res.data.msg
        } else {
          throw '해당 주문들에 대한 입금 완료 처리에 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.'
        }
      } catch (error) {
        setIsLoading(false)
        console.log('handleDepositComplete edit error', error)
        alert(error)
      }
    }
  }
  // useEffect(() => {
  //   console.log('totaldd', totalOrderList)
  // }, [totalOrderList])

  /**
   * 무통장 입금 주문건 취소 처리 ok handler
   */
  const handleDepositCancelModalOk = async () => {
    setIsLoading(true)
    try {
      let cancelInfoList = []
      let cancelAlertList = []
      let cancelCouponParamList = []
      let cancelUsePointParamList = []
      const orderIdSet = new Set(selectedRow.map((row) => row.orderId))
      for (const orderId of [...orderIdSet]) {
        const orderDetailList = selectedRow.filter(
          (row) => row.orderId === orderId,
        )
        let cancelCouponIdList = []
        for (const orderDetail of orderDetailList) {
          if (orderDetail.couponId !== null) {
            cancelCouponIdList.push(orderDetail.couponId)
          }
        }
        const cancelInfo = {
          totalOrder: {
            id: orderId,
            createdBy: orderDetailList[0].createdBy,
            orderStatus: 'cancel_complete',
          },
          orderDetailList: orderDetailList.map((orderDetailInfo) => {
            return {
              orderDetailId: orderDetailInfo.orderDetailId,
            }
          }),
          cancelReason: editCancelReason.cancelReason,
          cancelReasonDetail:
            Object.prototype.hasOwnProperty.call(
              editCancelReason,
              'cancelReasonDetail',
            ) &&
            editCancelReason.cancelReasonDetail !== null &&
            editCancelReason.cancelReasonDetail !== ''
              ? editCancelReason.cancelReasonDetail
              : '',
          cancelRequestUser: 'ADMIN',
          refundHolder: null,
          refundBank: null,
          refundAccount: null,
        }
        cancelInfoList.push(cancelInfo)
        // 취소 안내 알림톡 내용
        const cancelAlert = {
          orderId: orderId,
          phone: orderDetailList[0].phone,
          productName:
            orderDetailList?.length > 1
              ? `${orderDetailList[0].brandName} ${
                  orderDetailList[0].productName
                } 외 ${orderDetailList?.length - 1}건`
              : `${orderDetailList[0].brandName} ${orderDetailList[0].productName}`,
          cancelReason: editCancelReason.cancelReason,
          cancelReasonDetail:
            Object.prototype.hasOwnProperty.call(
              editCancelReason,
              'cancelReasonDetail',
            ) &&
            editCancelReason.cancelReasonDetail !== null &&
            editCancelReason.cancelReasonDetail !== ''
              ? editCancelReason.cancelReasonDetail
              : null,
        }
        cancelAlertList.push(cancelAlert)
        // 사용 쿠폰 환급
        if (cancelCouponIdList?.length !== 0) {
          const cancelCoupon = {
            couponIdList: cancelCouponIdList,
            userCouponIsAvailable: true,
            userId: orderDetailList[0].createdBy,
          }
          cancelCouponParamList.push(cancelCoupon)
        }
        // UserOrder > 사용 포인트 환급
        if (orderDetailList[0].usePoint !== null) {
          const cancelPointParam = {
            totalOrder: {
              id: orderId,
            },
          }
          cancelUsePointParamList.push(cancelPointParam)
        }
      }
      for (const cancelInfo of cancelInfoList) {
        const cancelRes = await orderApi.orderEdit(cancelInfo, user.id)
        if (cancelRes.data.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel()
          }, 1000)
          if (cancelRes.data.code === 999) {
            throw cancelRes.data.msg
          } else {
            throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
        }
      }
      for (const cancelCouponParam of cancelCouponParamList) {
        const cancelCouponRes = await promotionApi.userCouponChangeStatus(
          cancelCouponParam,
          user.id,
        )
        if (cancelCouponRes.data.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel()
          }, 1000)
          if (cancelCouponRes.data.code === 999) {
            throw cancelCouponRes.data.msg
          } else {
            throw `선택한 주문건들 중 사용한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
        }
      }
      for (const cancelPointParam of cancelUsePointParamList) {
        const cancelPointRes = await orderApi.purchasePointCancel(
          cancelPointParam,
          user.id,
        )
        if (cancelPointRes.data.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel()
          }, 1000)
          if (cancelPointRes.data.code === 999) {
            throw cancelPointRes.data.msg
          } else {
            throw `주문번호: ${cancelPointParam.totalOrder.id} 인 주문건에서 사용한 포인트를 환급하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
        }
      }
      const kakaoAlertParam = {
        orderDetailDTOList: cancelAlertList,
      }
      const kakaoRes = await pushApi.kakaoForDepositCancel(
        kakaoAlertParam,
        user.id,
      )
      if (kakaoRes.data.code !== 200) {
        setTimeout(() => {
          handelDepositCancelModalCancel()
        }, 1000)
        throw `해당 주문건들에 대한 알림톡을 전송하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
      }
      setIsLoading(false)
      alert('해당 주문건들이 성공적으로 취소되었습니다.')
      setTimeout(() => {
        handelDepositCancelModalCancel()
      }, 1000)
      // if (searchText && searchText !== ' ' && searchText === 'ready') {
      //   getUserOrderList('custom', searchText)
      // } else {
      //   getUserOrderList()
      // }
      getUserOrderList()
    } catch (e) {
      setIsLoading(false)
      console.log('handleDepositCancelModalOk error', e)
      alert(e)
    }
  }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            // orderId: row.orderId,
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            // orderId: row.orderId,
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else {
        alert(
          '다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.',
        )
        throw 'no data'
      }
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(excelData)
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
        ws[cellAdd].v = statusUtil.matchingKey[key]
      })
      XLSX.utils.book_append_sheet(wb, ws, '주문통합검색')
      XLSX.writeFile(wb, `${dayjs().format('YYYYMMDD')}_주문통합검색.xlsx`)
    } catch (error) {
      setIsLoading(false)
      console.log('handleExcelDownloadClick edit error', error)
    }
  }

  /**
   * 선택 주문 SMS 전송
   */
  const sendSms = () => {
    if (
      window.confirm('선택한 주문들의 구매자분들에게 SMS를 전송하시겠습니까?')
    ) {
      let orderSmsList = []
      const orderIdSet = new Set(selectedRow.map((row) => row.orderId))
      for (const orderId of [...orderIdSet]) {
        const orderDetailList = selectedRow.filter(
          (row) => row.orderId === orderId,
        )
        const findIdx = orderSmsList.findIndex(
          (order) => order.phone === orderDetailList[0].phone,
        )
        if (findIdx === -1) {
          const order = {
            orderId: orderId,
            name: orderDetailList[0].name,
            phone: orderDetailList[0].phone,
          }
          orderSmsList.push(order)
        }
      }
      setSelectOrderList({
        ...selectOrderList,
        selectOrderList: orderSmsList,
      })
      navigate('/customer/send/sms')
    }
  }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setCurrentPageNumber(1)
        // setIsSearchText("");
        getUserOrderList('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[0].value,
      searchOrderId: '',
      searchProductName: '',
      funnel: 0,
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    setSelectedRowKey([])
    setSelectedRow([])
    // setIsSearchText("");
    getUserOrderList('initial')
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('paymentCreatedAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false)
    setOrderDetail({})
  }

  /**
   * 무통장 입금 주문건 취소 처리 cancel handler
   */
  const handelDepositCancelModalCancel = async () => {
    setIsDepositCancelModalOpen(false)
    setSelectedRow([])
    setSelectedRowKey([])
    setEditCancelReason({
      cancelReason: null,
      refundBank: null,
    })
  }

  /**
   * 입금완료 disabled
   */
  const disabledDepositComplete = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let validList = []
      for (const row of selectedRow) {
        if (row.orderDetailStatus === 'ready') {
          validList.push(true)
        } else {
          validList.push(false)
        }
      }
      return !validList.every((result) => result)
    }
  }

  return (
    <>
      <ContentHeader title="주문통합검색" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/*주문검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            id={`body-mobile`}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: 'left' }}
            >
              {searchDateItems.map((item, idx) => (
                <Select.Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ marginTop: 10, gap: 5 }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, startDate: value })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, endDate: value })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {orderStatusItems.map((item, idx) => (
                <Select.Option
                  key={`order_status_search_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>
                  주문번호
                </div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/
                    if (reg.test(e.target.value) || e.target.value === '') {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      })
                    }
                  }}
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>상품명</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>이름</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>
        {/*주문목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          {mediaResult && (
            <button
              className={`${styles['order-column-change-button']}`}
              onClick={() => {
                setMobileColumn(!mobileColumn)
              }}
            >
              {mobileColumn ? '기존으로 전환' : '이름/가격 우선으로 전환'}
            </button>
          )}
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              주문목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          <Row
            align={'middle'}
            style={{
              gap: 10,
            }}
          >
            <Button
              className={`${styles['order-excel-download-btn']}`}
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
            <Button disabled={disabledDepositComplete()} onClick={sendSms}>
              무통장 주문 SMS
            </Button>
            <Button
              disabled={disabledDepositComplete()}
              onClick={() => setIsDepositCancelModalOpen(true)}
            >
              무통장 주문 취소
            </Button>
            <Button
              disabled={disabledDepositComplete()}
              onClick={handleDepositComplete}
            >
              무통장 입금완료
            </Button>
          </Row>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={mobileColumn ? columnsChange : columns}
            dataSource={orderList}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: 'max-content' }}
            onChange={tableOnChange}
            pagination={false}
            // sortDirections={false}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            backgroundColor: '#f8f9fd',
            height: 'fit-content',
            padding: '15px 25px',
          }}
        >
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="주문관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            발주/발송처리
            <img
              className={`${styles['order-bottom-form-item-arrow-icon']}`}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
              style={{ verticalAlign: 'middle', marginLeft: '4px' }}
            />
            배송지 정보 수정
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="취소관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            판매자 직접 취소 처리
            <img
              className={`${styles['order-bottom-form-item-arrow-icon']}`}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
              style={{ verticalAlign: 'middle', marginLeft: '4px' }}
            />
            취소 승인처리
            {/* <img
              className={`${styles['order-bottom-form-item-arrow-icon']}`}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
            />
            구매확정 후 취소처리 */}
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="반품교환관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            반품 및 교환접수
            <img
              className={`${styles['order-bottom-form-item-arrow-icon']}`}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
              style={{ verticalAlign: 'middle', marginLeft: '4px' }}
            />
            반품접수 후 처리
          </Form.Item>
        </div>
      </div>

      {/*주문 상세 페이지*/}
      {isOrderModalOpen && (
        <Modal
          title="상품주문정보 조회"
          wrapClassName="order-detail-modal-wrap"
          open={isOrderModalOpen}
          centered={true}
          onCancel={handleOrderDetailModalCancel}
          footer={null}
          width="70%"
        >
          <OrderDetailComponent
            orderDetail={orderDetail}
            handleOrderDetailModalCancel={handleOrderDetailModalCancel}
            getUserOrderList={getUserOrderList}
          />
        </Modal>
      )}

      {/*무통장 주문 취소 처리*/}
      {isDepositCancelModalOpen && (
        <Modal
          title="무통장 주문 취소"
          open={isDepositCancelModalOpen}
          onCancel={handelDepositCancelModalCancel}
          onOk={handleDepositCancelModalOk}
          cancelText={<span>닫기</span>}
          okText={<span>주문 취소</span>}
          confirmLoading={isLoading}
          width={'50%'}
        >
          <Form.Item
            label="주문 취소 사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            required
          >
            <Select
              placeholder="선택"
              value={editCancelReason.cancelReason}
              onChange={(value) =>
                setEditCancelReason({
                  ...editCancelReason,
                  cancelReason: value,
                })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {cancelReasonItems.map((item, idx) => (
                <Select.Option
                  key={`order_cancel_reason_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="구매자에게 전하실 말씀"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input.TextArea
              className="order-modal-address-request-wrap"
              name="cancelReasonDetail"
              value={editCancelReason.cancelReasonDetail}
              onChange={(e) =>
                setEditCancelReason({
                  ...editCancelReason,
                  [e.target.name]: e.target.value,
                })
              }
              rows={5}
            />
          </Form.Item>
        </Modal>
      )}
    </>
  )
}

export default OrderSearchListPage
